import { RouterProvider } from "react-router-dom";
import router from "./routes";
function App() {
  // const [loading, setLoading] = useState(true);
  // const [fade, setFade] = useState(false);

  // useEffect(() => {
  //   if (!loading) return;

  //   const fadeTimer = setTimeout(() => {
  //     setFade(true);
  //   }, 2500);

  //   const endTimer = setTimeout(() => {
  //     sessionStorage.setItem("introPlayed", "true");
  //     setLoading(false);
  //   }, 2400);

  //   return () => {
  //     clearTimeout(fadeTimer);
  //     clearTimeout(endTimer);
  //   };
  // }, [loading]);

  // if (loading) {
  //   return <Intro fade={fade} />;
  // }

  return <RouterProvider router={router} />;
}

export default App;
